<template></template>

<script>
import axios from "axios";
export default {
    data() {
      return {
          component: null,
          source: null,
          translation: null,
          editUrl: null,
          checking: false,
      }
    },
    methods: {
        saveAction() {
            if (!this.component || !this.source) {
                return
            }
            this.editUrl = null;
            this.checking = true;
            const response = axios.post(route('translations.checkIfExist', {
                source: this.source,
                component: this.component,
            }))
            .then(response => {
                this.checking = false;
                this.editUrl = response.data.url;
                if (!this.editUrl) {
                    this.$refs.form.submit();
                }
            })
        }
    },
    computed: {
        isDisabled() {
            return !(this.source && this.component);
        },
        saveText() {
            return this.checking ? "Checking..." : "Save";
        }
    }
}
</script>
